const dateList = {
  stopDisplayingAfterDays: 1,
  list: [
    {
      title: "message.date.title.FSEAST",
      date: "08/01/2023", // mm/dd/yyyy
      hour: "10:00:00", // hours:minutes:secondes
      link: "https://fseast.eu/",
    },
    {
      title: "message.date.title.FSG",
      date: "08/14/2023", // mm/dd/yyyy
      hour: "10:00:00", // hours:minutes:secondes
      link: "https://www.formulastudent.de/fsg/",
    },
    {
      title: "message.date.title.FSAA",
      date: "08/21/2023", // mm/dd/yyyy
      hour: "10:00:00", // hours:minutes:secondes
      link: "https://fs-alpeadria.com/",
    },
  ],
};

export default dateList;
